import type { DatasetWrapperProps } from "./dataset-wrapper.type";

import { Typography } from "antd";
import { useTranslation } from "react-i18next";

import { DatasetLoader } from "@/modules/dataset/dataset-loader";
import { useDatasetsMutatorDatasetTypeStatus } from "@/modules/datasets/datasets-mutator";

const { Text } = Typography;

export const DatasetWrapper = ({
  datasetType,
  loading,
  children,
}: DatasetWrapperProps) => {
  const { t } = useTranslation();
  const { toBeDeleted, isSaving } =
    useDatasetsMutatorDatasetTypeStatus(datasetType);

  if (loading || isSaving) {
    return <DatasetLoader type={datasetType} />;
  }

  if (toBeDeleted) {
    return (
      <Text className="dataset-wrapper-delete-warning" type="warning">
        {t("dataset:saveToDelete")}
      </Text>
    );
  }

  return children;
};
